import { TreePine } from 'lucide-react';

/**
 * MyRootsInlineCallout — "Your great-grandfather was alive when this was being
 * written." Inline with the script section where ancestor era overlaps.
 *
 * Source-derived. The intersection messages are server-side template strings
 * computed from the user's own family-data crossed with the chain step's
 * facts (server `_intersection_message`); no LLM, no narrative invention. Per
 * methodology hold #5: the platform doesn't narrate stories — it surfaces
 * intersections the user themselves recorded.
 */
export default function MyRootsInlineCallout({ intersections, era }) {
  if (!intersections || intersections.length === 0) return null;
  const top = intersections.slice(0, 2);
  return (
    <aside
      className="my-8 border rounded-md p-5"
      style={{
        borderColor: `${era.accent}55`,
        background: `linear-gradient(135deg, ${era.accent}0d, transparent)`,
      }}
      data-testid="myroots-inline-callout"
    >
      <div className="flex items-center gap-2 mb-3">
        <TreePine size={14} style={{ color: era.accent }} />
        <p className="font-hud text-[9px] tracking-[0.18em] uppercase" style={{ color: era.accent }}>
          YOUR LINEAGE INTERSECTS HERE
        </p>
      </div>
      <div className="space-y-2.5">
        {top.map((it, i) => (
          <p
            key={`${it.ancestor_id}-${it.step_key}-${i}`}
            className="font-historical text-base md:text-lg leading-snug"
            style={{ color: era.text }}
          >
            {it.message}
          </p>
        ))}
      </div>
    </aside>
  );
}
